export default "__VITE_ASSET__p$rcBx6n__"